/**
 * Shared chart styling for the eval charts (VISUAL_DESIGN_PRINCIPLES §3):
 * one warm-olive line tone and near-invisible fixed-size dots. Lives
 * outside the component files so react-refresh stays happy.
 */

/** Chart line tone: warm neutral olive — the mock's single-line color. */
export const CHART_INK = 'hsl(56 6% 46%)'

/**
 * Fixed-radius dot renderer — ZAxis-based sizing proved unreliable for
 * scatter symbols, and the mock wants near-invisible points anyway.
 */
export function tinyDot(radius: number, fill: string) {
  return function TinyDot({ cx, cy }: { cx?: number; cy?: number }): React.JSX.Element {
    if (cx === undefined || cy === undefined) return <g />
    return <circle cx={cx} cy={cy} r={radius} fill={fill} />
  }
}

/**
 * Reference lines (random / a baseline / SOTA) read as marks on the paper
 * rather than series: dashed and muted, so the single ink climb line still
 * carries the eye. Dash-over-hue is the sanctioned differentiator
 * (design-principles §3).
 */
export const CHART_REFERENCE_STROKE = 'hsl(var(--muted-foreground) / 0.5)'
export const CHART_REFERENCE_DASH = '4 4'
